module.exports = __webpack_public_path__ + "name=img/src/assets/story/5.jpg?4041cf60bd6fe92a04ada3554bc7dcf5";